import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, Button, TextField, IconButton, Tooltip, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function ProductCategoryMaster() {
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [categoryPlanName, setCategoryPlanName] = useState();
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchPlanCategory();
    }, []);
    const fetchPlanCategory = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditState(null);
        setCategoryPlanName("");
        setOpenModal(true);
    };
    const handleEdit = (data) => {
        setEditState(data);
        setCategoryPlanName(data.category_name);
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false);
        setCategoryPlanName("");
    };
    const handleSave = async () => {
        if (!categoryPlanName.trim()) {
            setMessage("Product Category Name Required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editState) {
                const stateEditData = {
                    category_name: categoryPlanName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "productcategory/" + editState.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("Product Category Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const stateAddData = {
                    category_name: categoryPlanName,
                    image_url: ""
                };
                try {
                    let url = webEndPoint + "productcategory";
                    const response = await makeRequest("post", url, stateAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("Product Category Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            fetchPlanCategory();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filtereddataSource = dataSource?.filter((d) =>
        d?.category_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Category Name", "Action"];
    const rows = filtereddataSource.map((data, index) => [index + 1, data?.category_name,
    <Box>
        <Tooltip title="Edit Plan Category">
            <IconButton color="primary" onClick={() => handleEdit(data)}><EditIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Product category Master</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", mb: 2, width: '100%' }}>
                <TextField label="Search Product Category" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal}>Add Product Category</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle> {editState ? "Edit Product Category" : "Add Product Category"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField label="Plan Category Name" value={categoryPlanName} onChange={(e) => setCategoryPlanName(e.target.value)} sx={{ mt: 2 }} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
